import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import { createHcTask, deleteHcTask as _deleteHcTask, deleteHcTaskByIds, updateHcTask, findHcTask, getHcTaskList, getHCLastUpdateTime as _getHCLastUpdateTime } from "@/api/biz_hc_task"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
import hcDomain from '@/view/healthCheck/hcTask/hcDomain.vue';
var methodOptions = [{
  value: "1",
  label: "UP"
}, {
  value: "2",
  label: "Down"
}];
export default {
  components: {
    hcDomain: hcDomain
  },
  name: "HcTask",
  mixins: [infoList],
  data: function data() {
    return {
      showDomain: false,
      taskId: 0,
      listApi: getHcTaskList,
      dialogFormVisible: false,
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        tplId: 0,
        ip: "",
        status: false,
        teamId: 0
      },
      methodOptions: methodOptions,
      LastSyncHcIpsTime: 0
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm");
      } else {
        return "";
      }
    },
    formatStatus: function formatStatus(status) {
      if (status == 1) {
        return 'UP';
      } else if (status == 2) {
        return 'Down';
      } else {
        return 'Progress';
      }
    },
    formatType: function formatType(type) {
      if (type == 1) {
        return 'http';
      } else if (type == 2) {
        return 'https';
      } else if (type == 3) {
        return 'tcp';
      } else if (type == 4) {
        return 'ping';
      } else {
        return '-';
      }
    },
    formatUrl: function formatUrl(row) {
      if (row.type == 3 || row.type == 4) {
        return '-';
      } else {
        var scheme = 'http';
        if (row.type == 2) {
          scheme = 'https';
        }
        return scheme + '://' + row.hostName + ':' + row.port + row.url;
      }
    },
    formatPort: function formatPort(row) {
      if (row.type == 4) {
        return '-';
      }
      return row.port;
    },
    formatDomain: function formatDomain(data) {
      if (data != "." && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRow: function deleteRow(row) {
      var _this = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteHcTask(row);
      });
    },
    getHCLastUpdateTime: function getHCLastUpdateTime() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getHCLastUpdateTime();
            case 2:
              res = _context.sent;
              if (res.data) {
                _this2.LastSyncHcIpsTime = res.data;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onDelete: function onDelete() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ids, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              ids = [];
              if (!(_this3.multipleSelection.length == 0)) {
                _context2.next = 4;
                break;
              }
              _this3.$message({
                type: 'warning',
                message: '请选择要删除的数据'
              });
              return _context2.abrupt("return");
            case 4:
              _this3.multipleSelection && _this3.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context2.next = 7;
              return deleteHcTaskByIds({
                ids: ids
              });
            case 7:
              res = _context2.sent;
              if (res.code == 0) {
                _this3.$message({
                  type: 'success',
                  message: '删除成功'
                });
                if (_this3.tableData.length == ids.length) {
                  _this3.page--;
                }
                _this3.deleteVisible = false;
                _this3.getTableData();
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    updateHcTask: function updateHcTask(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return findHcTask({
                ID: row.ID
              });
            case 2:
              res = _context3.sent;
              _this4.type = "update";
              if (res.code == 0) {
                _this4.formData = res.data.rebizHcTask;
                _this4.dialogFormVisible = true;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        tplId: 0,
        ip: "",
        status: false,
        teamId: 0
      };
    },
    deleteHcTask: function deleteHcTask(row) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _deleteHcTask({
                ID: row.ID
              });
            case 2:
              res = _context4.sent;
              if (res.code == 0) {
                _this5.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this5.tableData.length == 1) {
                  _this5.page--;
                }
                _this5.getTableData();
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = _this6.type;
              _context5.next = _context5.t0 === "create" ? 3 : _context5.t0 === "update" ? 7 : 11;
              break;
            case 3:
              _context5.next = 5;
              return createHcTask(_this6.formData);
            case 5:
              res = _context5.sent;
              return _context5.abrupt("break", 15);
            case 7:
              _context5.next = 9;
              return updateHcTask(_this6.formData);
            case 9:
              res = _context5.sent;
              return _context5.abrupt("break", 15);
            case 11:
              _context5.next = 13;
              return createHcTask(_this6.formData);
            case 13:
              res = _context5.sent;
              return _context5.abrupt("break", 15);
            case 15:
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: "创建/更改成功"
                });
                _this6.closeDialog();
                _this6.getTableData();
              }
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    },
    showRelateDomain: function showRelateDomain(row) {
      this.showDomain = true;
      this.taskId = row.id;
    },
    openDomainPage: function openDomainPage() {
      this.$refs.hcDomain.loadDomainList(this.taskId);
    },
    tagType: function tagType(type) {
      var tagType = '';
      switch (type) {
        case 2:
          tagType = 'success';
          break;
        case 3:
          tagType = 'warning';
          break;
        case 4:
          tagType = 'danger';
          break;
      }
      return tagType;
    }
  },
  mounted: function mounted() {
    var _this7 = this;
    this.getHCLastUpdateTime();
    //定时器
    var timer = setInterval(function () {
      _this7.getHCLastUpdateTime(); //你所加载数据的方法
    }, 60000);
    //销毁定时器
    this.$once('hook:beforeDestroy', function () {
      clearInterval(timer);
    });
  },
  created: function created() {
    var _this8 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (_this8.$route.query.domain) {
              _this8.$set(_this8.searchInfo, 'domain', _this8.$route.query.domain + '$');
            }
            if (_this8.$route.query.id) {
              _this8.$set(_this8.searchInfo, 'ID', _this8.$route.query.id);
            }
            _context6.next = 4;
            return _this8.getTableData();
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  }
};